import {UyapRequest} from "./UyapRequest";

export interface IcraTebligatTalebiAdresSorgulaTalep {
    dosyaId: string,
    kisiKurumId: number,
    kayitId: number,
    adresTuru: string
}

// tebligat adres türü = 0 => adresTuru = "ADRTR00013"
// tebligat adres türü = 1 => adresTuru = "ADRTR00008"
// tebligat adres türü = 2 => adresTuru = "ADRTR00011"

export interface IcraTebligatTalebiAdresSorgulaCevap {
    ilKodu: number,
    ilAdi: string,
    ilceAdi: string,
    ilceKodu: number,
    adres: string,
    adresTuru: string,
    adresTuruAciklama: string,
    girisTarihi: string,
    eklenebilirAdresMi: boolean,
    kayitliAdresMi: boolean,
    aktifAdresmi: boolean,
    guncellendiMi: boolean
}

export default class IcraTebligatTalebiAdresSorgula extends UyapRequest<IcraTebligatTalebiAdresSorgulaTalep, IcraTebligatTalebiAdresSorgulaCevap> {
    getMethod(): "POST" | "GET" {
        return "POST";
    }

    getSpinnerMessage(){
        return "İcra tebligat talebi adres sorgulanıyor...";
    }

    cache() {
        return {
            active: false,
            ttl: (60 * 24), //* 1 gun
            key: "_"
        };
    }

    getUrl(): string {
        return this.ImzaClientAddr + "main/jsp/avukat/getIcraTebligatTalebiAdresSorgula.ajx";
    }

    async parse(data: any): Promise<IcraTebligatTalebiAdresSorgulaCevap> {
        return data;
    }

    getMockResponse(): any {
        return {
            "ilKodu": 35,
            "ilAdi": "İZMİR",
            "ilceAdi": "KARABURUN",
            "ilceKodu": 15,
            "adres": "",
            "adresTuru": "ADRTR00008",
            "adresTuruAciklama": "Mernis Adresi",
            "girisTarihi": "14/02/2023",
            "eklenebilirAdresMi": false,
            "kayitliAdresMi": false,
            "aktifAdresmi": false,
            "guncellendiMi": false
        };
        // e-tebligat responce
        // return {"adres":"25111-87111-48111","eklenebilirAdresMi":false,"kayitliAdresMi":false,"aktifAdresmi":false,"guncellendiMi":false};
    }
}